import {useQuery} from 'react-query'

export const useSimpleQuery = (props) =>
  useQuery({
    retry: false,
    retryOnMount: false,
    refetchOnMount: true,
    refetchOnWindowFocus: false,
    refetchOnReconnect: false,
    ...props
  })
